export const sources={webp:"__VITE_ASSET__BJRc_alP__ 74w"};export const img={src:"__VITE_ASSET__CyoX$Ky2__",w:74,h:90};export default{sources:sources,img:img};